<div class="content-label-container">
    <h1 translate>terms.title</h1>
</div>

<div class="content-main-container">
    <div class="terms_paragraph_emphasis">
        <span translate>terms.section01</span>
    </div>
    <div class="terms_paragraph">
        <span translate>terms.sentence01</span>
    </div>
    <div class="terms_paragraph_emphasis">
        <span translate>terms.section02</span>
    </div>
    <div class="terms_paragraph">
        <span translate>terms.sentence02</span>
    </div>
    <div class="terms_paragraph_emphasis">
        <span translate>terms.section03</span>
    </div>
    <div class="terms_paragraph">
        <span translate>terms.sentence03</span>
    </div>
    <div class="terms_paragraph_emphasis">
        <span translate>terms.section04</span>
    </div>
    <div class="terms_paragraph">
        <span translate>terms.sentence04-1</span>
        <a href="https://irisconnect.jp/" target="_blank" rel="noopener noreferrer">https://irisconnect.jp/</a>
        <span translate>terms.sentence04-2</span>
    </div>
    <div class="terms_paragraph_emphasis">
        <span translate>terms.section05</span>
    </div>
    <div class="terms_paragraph">
        <span translate>terms.sentence05</span>
    </div>

    <div class="terms_paragraph_sub">
        <span class="title" translate>terms.contact_title</span>
        <br>
        <span translate>terms.contact_summary-1</span>
        <a routerLink="/privacy" translate>privacy.title</a>
        <span translate>terms.contact_summary-2</span>
    </div>
</div>